// extracted by mini-css-extract-plugin
export default {"drawer":"b9MwvBO5v9GkEseHic3obg=="};